module.exports = __webpack_public_path__ + "7a9d18e9d4481c36117f9135946e2374.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/images/3.jpg
// module id = ./src/components/Carousel/images/3.jpg
// module chunks = 0